import clsx from 'clsx';
import React from 'react';

import type { ColorType, TextSizeType } from '../utils';
import { colorToHexCode, fontSizeTailwindConfig } from '../utils';

export type LineDividerProps = {
  /** Matches shared `fontSizeTailwindConfig` line-height for the given size. */
  size?: TextSizeType;
  color?: ColorType;
  className?: string;
  'data-testid'?: string;
};

export const LineDivider = ({
  size = 'sm',
  color = 'gray400',
  className,
  'data-testid': testId,
}: LineDividerProps): JSX.Element => {
  const lineHeightPx = fontSizeTailwindConfig[size][1];

  return (
    <div
      className={clsx('flex w-full min-w-0 shrink-0 items-center', className)}
      data-testid={testId}
      role="separator"
      style={{ height: lineHeightPx }}
    >
      <svg
        aria-hidden
        className="block h-px w-full min-w-0"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 100 1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          stroke={colorToHexCode[color]}
          strokeWidth={1}
          vectorEffect="nonScalingStroke"
          x1="0"
          x2="100"
          y1="0.5"
          y2="0.5"
        />
      </svg>
    </div>
  );
};
